import ObjectCopyService from "external-services/object-copy-service/index";
import { LocaleService } from 'app/services/locale/locale.service';
import ConvertJsonToCsv from "app/services/jsonToCsv/jsonToCsv.service";
import EventsService from 'app/services/events/events.service';
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import BookingService from "app/services/booking/booking.service";
import DateUtilsService from 'external-services/date-utils-service';
import AdminService from 'external-services/diary-admin-service/admin.service';

const NS = 'OverviewCtrl'; // jshint ignore:line

export default function OverviewCtrl(
  $rootScope, $log, $scope, $filter,
  scheduleService
) {
  "ngInject";

  const vm = this;

  var groupedServices = [];
  var eventServiceGroups = [];
  var changeTimeout;

  //-- define public properties
  const timeZoneId = AdminService.getVenueTimezoneId();
  vm.startDate = DateUtilsService.getClearDate(null, timeZoneId);
  vm.endDate = DateUtilsService.getClearDate(null, timeZoneId);
  vm.endDate.setDate(vm.endDate.getDate() + 1);
  vm.breakdowns = [{
    name: 'Bookings',
    prop: 'bookings'
  }, {
    name: 'Covers',
    prop: 'covers'
  }, {
    name: 'Phone',
    prop: 'phone'
  }, {
    name: 'Email',
    prop: 'email'
  }, {
    name: 'Online',
    prop: 'online'
  }, {
    name: 'Walkins',
    prop: 'walkin'
  }];
  vm.hideDays = true;
  vm.loadError = false;
  vm.loading = true;
  vm.serviceIndex = 0;
  //-- define public methods
  vm.displayProp = displayProp;
  vm.printReport = printReport;
  vm.exportToCsv = exportToCsv;
  vm.countSection = countSection;

  init();

  function changeDetected() {
    clearTimeout(changeTimeout);
    changeTimeout = setTimeout(datesChanged, 300);
  }

  function init() {
    scheduleService.getDaySchedules().then(function (schedules) {
      var serviceGroup;
      var servicesLookUp = {};
      groupedServices = [];
      // merge services
      for (var i = schedules.length - 1; i >= 0; i--) {
        var schedule = schedules[i];
        for (var s = schedule.services.length - 1; s >= 0; s--) {
          var service = schedule.services[s];
          var key = service.name.toLowerCase();
          if (isNaN(servicesLookUp[key])) {
            serviceGroup = {
              name: service.name,
              ids: [],
              startTime: service.startTime,
              endTime: service.endTime
            };
            servicesLookUp[key] = groupedServices.length;
            groupedServices.push(serviceGroup);
          }
          serviceGroup = groupedServices[servicesLookUp[key]];
          serviceGroup.ids.push(service._id);
        }
      }
      return SectionLookupService.getSections();
    }).then(function (sectionsList) {
      // get all sections
      vm.sections = $filter('orderBy')(sectionsList, 'order');
      // Add wait List to sections
      vm.sections.push({
        _id: 'waitList',
        _rev: '',
        name: "Wait List",
        order: 100,
        type: 'section'
      });
      vm.selectedSections = vm.sections.map(function (s) {
        return s._id;
      });
      return true;
    }).then(function () {
      //-- listen
      $scope.$watch('vm.startDate', changeDetected);
      $scope.$watch('vm.endDate', changeDetected);
      $scope.$watch('vm.serviceIndex', filterBookings);
      $scope.$watch('vm.selectedSections', filterBookings);
    }).catch(function (error) {
      console.error('init error', error);
    });
  }

  function datesChanged() {
    vm.loading = true;
    vm.loadError = false;
    vm.serviceIndex = 0;
    EventsService.getEventsBetweenDates(vm.startDate, vm.endDate).then(function (events) {
      eventServiceGroups = [];
      for (var e = events.length - 1; e >= 0; e--) {
        var event = events[e];
        var eventServiceGroup = {
          name: event.name,
          ids: [event._id],
          startTime: event.startTime,
          endTime: event.endTime
        };

        eventServiceGroups.push(eventServiceGroup);
      }
      return getBookings();
    }).then(function () {
      vm.loading = false;
    }).catch(function () {
      vm.loading = false;
      vm.loadError = true;
    });
  }

  function getBookings() {
    // get bookings
    return BookingService.getBetweenDates(vm.startDate, vm.endDate).then(function (results) {
      vm.bookings = results;
      return vm.bookings;
    }).then(function () {
      return filterBookings();
    });
  }

  function filterBookings() {
    if (!vm.bookings) {
      return;
    }

    var props = {
      bookings: 0,
      covers: 0,
      walkin: 0,
      email: 0,
      phone: 0,
      online: 0,
    };
    // loop over the bookings and put them in to services and layouts
    var sectionsLookUp = {};
    var sectionArray = [];

    for (var f = 0; f < vm.sections.length; f++) {
      sectionsLookUp[vm.sections[f]._id] = sectionArray.length;
      var sectionObj = Object.assign({
        _id: vm.sections[f]._id
      }, ObjectCopyService.angularSafeCopy(props));
      sectionArray.push(sectionObj);
    }

    props.bookingsBySection = ObjectCopyService.angularSafeCopy(sectionArray);
    var totals = ObjectCopyService.angularSafeCopy(props);

    var servicesTotals = [];
    var allAroupedServices = groupedServices.concat(eventServiceGroups);
    // Loop over services
    for (var s = 0; s < allAroupedServices.length; s++) {
      var serviceGroup = Object.assign(allAroupedServices[s], ObjectCopyService.angularSafeCopy(props));
      serviceGroup.count = true;
      if (Number(vm.serviceIndex) !== 0 && Number(vm.serviceIndex) !== (s + 1)) {
        serviceGroup.count = false;
      }
      servicesTotals.push(serviceGroup);
    }
    // loop over bookings object
    for (var i = vm.bookings.length - 1; i >= 0; i--) {
      var booking = vm.bookings[i];
      // Loop over services
      // only count bookings that turned up or are booked
      if (booking.status.statusType !== 'cancelled') {
        var serviceIndex = getServiceIndex(booking, servicesTotals);
        var countBooking = false;
        // count bookings in this service
        if (serviceIndex !== -1 && (Number(vm.serviceIndex) === 0 || Number(vm.serviceIndex) === (serviceIndex + 1))) {
          var sectionCounters;
          var totalsSection;
          countBooking = true;
          // place the booking in a section, use only the first table it is assigned to
          if (booking.tables && booking.tables.length) {
            var table = booking.tables[0];
            if (table) {
              // section
              countBooking = countSection(table.sectionId);
              if (countBooking) {
                sectionCounters = servicesTotals[serviceIndex].bookingsBySection[sectionsLookUp[table.sectionId]];
                sectionCounters.bookings++;
                sectionCounters.covers += booking.people;
                sectionCounters[booking.method]++;
                // total section
                totalsSection = totals.bookingsBySection[sectionsLookUp[table.sectionId]];
                totalsSection.bookings++;
                totalsSection.covers += booking.people;
                totalsSection[booking.method]++;
              }
            }
          }

          // add them to the waitlist
          if (!booking.tables || booking.tables.length === 0) {
            // section
            countBooking = countSection('waitList');
            if (countBooking) {
              sectionCounters = servicesTotals[serviceIndex].bookingsBySection[sectionsLookUp.waitList];
              sectionCounters.bookings++;
              sectionCounters.covers += booking.people;
              sectionCounters[booking.method]++;
              // total section
              totalsSection = totals.bookingsBySection[sectionsLookUp.waitList];
              totalsSection.bookings++;
              totalsSection.covers += booking.people;
              totalsSection[booking.method]++;
            }
          }
          if (countBooking) {
            // totals service
            servicesTotals[serviceIndex].bookings++;
            servicesTotals[serviceIndex].covers += booking.people;
            servicesTotals[serviceIndex][booking.method]++;
          }
        }
        // totals
        if (countBooking) {
          totals.bookings++;
          totals.covers += booking.people;
          totals[booking.method]++;
        }
      }
    }
    vm.totals = totals;
    vm.servicesTotals = servicesTotals;
    vm.serviceOptions = Object.assign([], vm.servicesTotals);
    vm.serviceOptions.unshift({
      name: "All"
    });
  }

  function countSection(sectionId) {
    return (vm.selectedSections.indexOf(sectionId) === -1) ? false : true;
  }

  function getServiceIndex(booking, services) {
    for (var i = 0; i < services.length; i++) {
      var service = services[i];
      if (booking.serviceId) {
        if (service.ids.indexOf(booking.serviceId) !== -1) {
          return i;
        }
      } else {
        var startTime = service.startTime;
        var endTime = service.endTime;
        startTime.setYear(booking.time.getYear());
        startTime.setMonth(booking.time.getMonth());
        startTime.setDate(booking.time.getDate());
        endTime.setYear(booking.time.getYear());
        endTime.setMonth(booking.time.getMonth());
        endTime.setDate(booking.time.getDate());
        if (endTime < startTime) {
          endTime.setDate(endTime.getDate() + 1);
        }

        if (DateUtilsService.isInBetweenDates(booking.time, startTime, endTime)) {
          return i;
        }
      }
    }
    return -1;
  }

  function displayProp(properties, prop) {
    if (properties) {
      if (prop === 'online' || prop === 'walkin' || prop === 'phone' || prop === 'email') {
        return percentage(properties[prop], properties.bookings);
      } else {
        return properties[prop];
      }
    }
  }

  function percentage(interger, total) {
    return (interger === 0) ? 0 + '%' : Math.round((interger / total) * 100) + '%';
  }

  function exportToCsv() {
    var reportName = 'BookingOverview_' + LocaleService.formatDateForFilename(vm.filterDate);
    var overviewExport = [];
    var section;
    var sections = ObjectCopyService.angularSafeCopy(vm.sections);
    var labels = [];

    for (var i = 0; i < sections.length; i++) {
      section = sections[i];
      labels.push(section.name);
    }

    var bookingsByService = [];
    var temp = ObjectCopyService.angularSafeCopy(vm.bookingsByService);

    for (var key in temp) {
      bookingsByService.push(temp[key]);
    }

    var breakdowns = ObjectCopyService.angularSafeCopy(vm.breakdowns);
    var property;

    for (var s = 0; s < bookingsByService.length; s++) {
      var service = bookingsByService[s];

      // Insert Name Here
      for (var p = 0; p < breakdowns.length; p++) {

        property = breakdowns[p];
        var row = {
          serviceName: service.name
        };

        // First Column is Property Name
        row.propertyName = property.name;

        for (var j = 0; j < service.bookingsBySection.length; j++) {
          section = service.bookingsBySection[j];
          // Insert Property Here
          row[labels[j]] = displayProp(section, property.prop);
        }

        row.total = displayProp(service, property.prop);
        overviewExport.push(row);
      }
    }

    // Totals for export
    var totals = ObjectCopyService.angularSafeCopy(vm.totals.bookingsBySection);
    var totalsExport = [];

    // Get Totals
    for (var q = 0; q < breakdowns.length; q++) {
      property = breakdowns[q];

      // Create Totals Array
      var rowTotal = {
        serviceName: 'Daily'
      };

      // First Column is Property Name
      rowTotal.propertyName = property.name;

      for (var n = 0; n < totals.length; n++) {
        section = totals[n];
        // Insert Property Here
        rowTotal[labels[n]] = displayProp(section, property.prop);
      }

      rowTotal.total = displayProp(vm.totals, property.prop);
      totalsExport.push(rowTotal);
    }

    overviewExport = overviewExport.concat(totalsExport);

    // Add Labels to Export
    labels.unshift('Service', 'Type');

    ConvertJsonToCsv.downloadCsv(overviewExport, labels, reportName);
  }

  // Print Report
  function printReport() {
    vm.printingOverview = true;
    setTimeout(function () {
      window.print();
      vm.printingOverview = false;
    }, 50);
  }
}
